export default __webpack_public_path__ + "static/media/businessimage.8ca6323b.svg";